// Aliased because the mobx-react export is named like a hook but is a plain setter, and
// calling it under its own name fails react-hooks/rules-of-hooks.
import { useStaticRendering as setMobxStaticRendering } from 'mobx-react'

export const isServerSide = (): boolean => typeof window === 'undefined'

/**
 * DVP-1403. mobx-react 6 gives every `observer` render a Reaction and disposes it only from a
 * useEffect cleanup, which SSR never runs, so each server render left one Reaction pinned to the
 * module-level stores for the life of the process. Static rendering skips creating them; nothing
 * is lost, since their only job is to call forceUpdate and SSR discards state updates anyway.
 */
export const applyMobxStaticRendering = (): void => {
	setMobxStaticRendering(isServerSide())
}
